import "core-js/modules/es.object.assign.js";
import Env from '../env';
import UA from '../ua';
var appName = UA.appName; // 根据appName 加载 配置文件

var Platform = require('./' + appName).default; // 处理部分默认逻辑


var _Platform$ajaxUrl = Platform.ajaxUrl,
    ajaxUrl = _Platform$ajaxUrl === void 0 ? 'https://yanchu.maoyan.com/myshow/ajax' : _Platform$ajaxUrl,
    _Platform$ajaxBetaUrl = Platform.ajaxBetaUrl,
    ajaxBetaUrl = _Platform$ajaxBetaUrl === void 0 ? '//m.51ping.com/myshow/ajax' : _Platform$ajaxBetaUrl,
    _Platform$hostPrefix = Platform.hostPrefix,
    hostPrefix = _Platform$hostPrefix === void 0 ? '//h5.dianping.com/app' : _Platform$hostPrefix,
    _Platform$hostPpePref = Platform.hostPpePrefix,
    hostPpePrefix = _Platform$hostPpePref === void 0 ? '//ppe.h5.dianping.com/app' : _Platform$hostPpePref,
    _Platform$hostBetaPre = Platform.hostBetaPrefix,
    hostBetaPrefix = _Platform$hostBetaPre === void 0 ? "//".concat(location.host, "/app") : _Platform$hostBetaPre;
var isProduct = Env.isProduct,
    isPpe = Env.isPpe,
    isLocal = Env.isLocal;
Object.assign(Platform, {
  ajaxUrl: ajaxUrl,
  ajaxBetaUrl: ajaxBetaUrl,
  hostPrefix: hostPrefix,
  hostBetaPrefix: hostBetaPrefix,
  hostPpePrefix: hostPpePrefix,
  urlPerfix: isProduct ? hostPrefix : isPpe ? hostPpePrefix : hostBetaPrefix
});
export default Platform;